module.exports = __webpack_public_path__ + "static/media/icon-learning.eea822a8.png";